module.exports = __webpack_public_path__ + "static/momLogo-c8c2ed0484ea2d103fc015f42a8be0a7.png";